import { fetchApi } from '@/config/axiosSetting';
import { PatchBodyInsuranceType } from '@/modules/adjusterReportModules/Insurer-information/queries/patchBodyInsurance/patchBodyInsurance.type';

export const patchBodyInsuranceFunction = ({
  id,
  formData,
}: PatchBodyInsuranceType) => {
  return fetchApi.patch(`/body/reports/${id}/insurance_information/`, {
    ...formData,
  });
};
